// src/pages/CouponList.jsx
import React, { useEffect, useMemo, useState } from "react";
import { subscribeList, updateData } from "../firebase/rtdb";

export default function CouponList() {
  const [coupons, setCoupons] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const unsubscribe = subscribeList("coupons", (arr) => {
      setCoupons(arr || []);
    });

    return () => unsubscribe();
  }, []);

  const formatDateTime = (value) => {
    if (!value) return "-";

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;

    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const filteredCoupons = useMemo(() => {
    const q = search.trim().toUpperCase();

    if (!q) return coupons;

    return coupons.filter((c) => {
      const text = [
        c._key,
        c.code,
        c.shopId,
        c.type,
        c.usedByShop,
        c.voucherNo,
        c.used ? "USED" : "UNUSED",
        c.approved ? "APPROVED" : "PENDING",
      ]
        .join(" ")
        .toUpperCase();

      return text.includes(q);
    });
  }, [coupons, search]);

  const handleApprove = async (code) => {
    if (!code) return;

    try {
      await updateData(`coupons/${code}`, {
        approved: true,
      });

      alert(`Coupon ${code} approved`);
    } catch (err) {
      console.error(err);
      alert("Approve failed");
    }
  };

  const handleCopy = async (code) => {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      alert(`Copied: ${code}`);
    } catch (err) {
      console.error(err);
      alert("Copy failed");
    }
  };

  return (
    <div className="coupon-list-container">
      <div className="coupon-list-header">
        <div>
          <h2>Coupon List</h2>
          <p>
            Created coupon တွေ၊ သုံးထားတဲ့ဆိုင်၊ voucher နဲ့ အသုံးပြုချိန်ကို
            ကြည့်ရန်
          </p>
        </div>

        <input
          className="coupon-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search code / shop / voucher..."
        />
      </div>

      <div className="coupon-table-wrap">
        <table className="coupon-table">
          <thead>
            <tr>
              <th>Coupon Code</th>
              <th>Allowed Shop</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Used</th>
              <th>Used By Shop</th>
              <th>Voucher No</th>
              <th>Used At</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredCoupons.length === 0 ? (
              <tr>
                <td colSpan="10" className="empty-row">
                  No coupons found
                </td>
              </tr>
            ) : (
              filteredCoupons.map((c) => {
                const code = c._key || c.code || "";
                const isUsed = c.used === true;
                const isApproved = c.approved === true;

                return (
                  <tr key={code}>
                    <td className="coupon-code">{code}</td>

                    <td>
                      {String(c.shopId || "").toUpperCase() === "ALL" ? (
                        <span className="badge badge-all">All Shops</span>
                      ) : (
                        <span className="badge badge-shop">
                          {c.shopId || "-"}
                        </span>
                      )}
                    </td>

                    <td>{c.type || "-"}</td>

                    <td>{Number(c.amount || 0).toLocaleString()} Ks</td>

                    <td>
                      {isApproved ? (
                        <span className="badge badge-approved">Approved</span>
                      ) : (
                        <span className="badge badge-pending">Pending</span>
                      )}
                    </td>

                    <td>
                      {isUsed ? (
                        <span className="badge badge-used">Yes</span>
                      ) : (
                        <span className="badge badge-unused">No</span>
                      )}
                    </td>

                    <td>{c.usedByShop || "-"}</td>

                    <td>{c.voucherNo || "-"}</td>

                    <td>{formatDateTime(c.usedAt)}</td>

                    <td>
                      <div className="coupon-actions">
                        {!isApproved && (
                          <button
                            type="button"
                            className="approve-btn"
                            onClick={() => handleApprove(code)}
                          >
                            Approve
                          </button>
                        )}

                        <button
                          type="button"
                          className="copy-btn"
                          onClick={() => handleCopy(code)}
                        >
                          Copy
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}